(() => {
  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLocaleLowerCase('fr-FR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const getSelectedColor = (section) => {
    const checkedColor =
      section.querySelector(
        'input[type="radio"][name*="Couleur" i]:checked, input[type="radio"][name*="Color" i]:checked'
      );

    if (checkedColor) return checkedColor.value;

    const colorSelect = section.querySelector(
      'select[name*="Couleur" i], select[name*="Color" i]'
    );

    return colorSelect?.value || '';
  };

  const getMediaAlt = (element) => {
    const image = element.querySelector('img');
    return image?.getAttribute('alt') || '';
  };

const filterGallery = (section) => {
  const colorInputs = section.querySelectorAll(
    'input[type="radio"][name*="Couleur" i], input[type="radio"][name*="Color" i]'
  );

  const colorSelect = section.querySelector(
    'select[name*="Couleur" i], select[name*="Color" i]'
  );

  const availableColors = new Set();

  colorInputs.forEach((input) => {
    if (input.value) {
      availableColors.add(normalize(input.value));
    }
  });

  if (colorSelect) {
    Array.from(colorSelect.options).forEach((option) => {
      if (option.value) {
        availableColors.add(normalize(option.value));
      }
    });
  }

  const gallery = section.querySelector('media-gallery');
  if (!gallery) return;

  const mediaItems = gallery.querySelectorAll(
    '[id^="Slide-"], [id^="Thumbnail-"]'
  );

  /*
   * S’il n’existe qu’une seule couleur,
   * on affiche toutes les images sans appliquer le filtrage.
   */
  if (availableColors.size <= 1) {
    mediaItems.forEach((item) => {
      item.hidden = false;
      item.style.display = '';
    });

    return;
  }

  const selectedColor = normalize(getSelectedColor(section));

  if (!selectedColor) return;

    let firstVisibleSlide = null;

    mediaItems.forEach((item) => {
      const alt = normalize(getMediaAlt(item));

      /*
       * Les images sans ALT de couleur restent visibles :
       * pictogrammes, certifications, guides, vidéos, etc.
       */
      const knownColorAlt = alt === selectedColor;
      const shouldRemainGeneral =
        !alt ||
        alt.includes('oeko') ||
        alt.includes('personne') ||
        alt.includes('guide') ||
        alt.includes('video');

      const visible = knownColorAlt || shouldRemainGeneral;

      item.hidden = !visible;
      item.style.display = visible ? '' : 'none';

      if (
        visible &&
        !firstVisibleSlide &&
        item.id.startsWith('Slide-')
      ) {
        firstVisibleSlide = item;
      }
    });

    if (firstVisibleSlide) {
      const mediaId = firstVisibleSlide.dataset.mediaId;

      if (mediaId && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, true);
      } else {
        firstVisibleSlide.scrollIntoView({
          behavior: 'auto',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    }
  };

  const initializeSection = (section) => {
    if (!section || section.dataset.colorGalleryInitialized === 'true') return;

    section.dataset.colorGalleryInitialized = 'true';

    section.addEventListener('change', (event) => {
      if (
        event.target.matches(
          'input[type="radio"], select'
        )
      ) {
        window.setTimeout(() => filterGallery(section), 150);
      }
    });

    filterGallery(section);
  };

  const initialize = () => {
    document
      .querySelectorAll('[id^="MainProduct-"], .shopify-section')
      .forEach((section) => {
        if (section.querySelector('media-gallery')) {
          initializeSection(section);
        }
      });
  };

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();